// extracted by mini-css-extract-plugin
export var brand = "_48-9";
export var compact = "_48-6";
export var extraSmall = "_48-7";
export var icon = "_48-0";
export var large = "_48-4";
export var light = "_48-1";
export var medium = "_48-5";
export var outline = "_48-b";
export var primaryDark = "_48-a";
export var primaryLight = "_48-8";
export var primaryModern = "_48-c";
export var success = "_48-2";
export var successSolid = "_48-3";